{
  "infoCard": {
    "labels": {
      "aircraft": "Aéronef",
      "utilization": "Utilisation",
      "trips": "Vols",
      "doorSize": "Taille porte",
      "estTowTime": "Tps remor.",
      "estValue": "Val. est.",
      "total": "Total",
      "transients": "Transients",
      "dimensions": "Dimensions",
      "parameters": "Paramètres"
    },
    "tooltips": {
      "aircraftCount": "# aéronefs dans le hangar / # aéronefs souhaités à l'intérieur",
      "utilization": "Utl. appareils empilés / Utl. tous les appareils à l'écran. Vous pouvez ajuster le calcul de l'utilisation dans Paramètres > Configuration.",
      "towTime": "Temps estimé pour sortir tous les aéronefs du hangar en remorquage.",
      "tripsCount": "Vols actifs / Vols à venir assignés à ce hangar",
      "estimatedValue": "Valeur estimée de votre hangar. Cela inclut tous les locataires permanents et les transients que vous pouvez accueillir dans le hangar.",
      "transientValue": "Revenue from overnight transient aircraft."
    },
    "units": {
      "perDay": " / jour",
      "perMonth": " / mois"
    }
  },
  "customStackDialog": {
    "title": "Personnalisez votre Stack",
    "buttons": {
      "back": "Retour",
      "runStack": "Lancer pile"
    },
    "sections": {
      "spacingSOP": "Espacement SOP",
      "preferences": "Préférences"
    },
    "labels": {
      "horizontal": "Horizontal (ft)",
      "vertical": "Verticale (ft)",
      "leftWall": "Mur gauche (pi)",
      "backWall": "Mur arrière (pi)",
      "rightWall": "Paroi droite (pi)",
      "towingEquipment": "Équipement de remorquage pour pile",
      "ignore": "Ignorer ?",
      "allowOverlap": "Chevauchement OK",
      "ignoreNoseInOut": "Ignorer les préférences nez entrant/sortant",
      "ignoreFrontBack": "Ignorer les préférences avant/arrière",
      "ignoreOutsideHangar": "Ignorer les préférences d'autorisation hors hangar",
      "cloudPrioritization": "Utiliser la priorisation de position Cloud",
      "sampleSize": "Échantillon",
      "cornerStrategy": "Stratégie d'angle",
      "xyWeights": "Masses XY",
      "xWeight": "X",
      "yWeight": "Y",
      "densityThreshold": "Seuil de densité 3D"
    },
    "tooltips": {
      "spacingSOP": "Remplacer les SOPs. Par défaut, les SOPs définis pour votre FBO seront utilisés.",
      "preferences": "Personnalisez vos préférences d'empilement. Elles s'appliqueront à tous les aéronefs."
    },
    "descriptions": {
      "allowOverlap": "Autoriser l'algorithme à superposer les avions.",
      "ignoreNoseInOut": "Autoriser l'algorithme à utiliser vos préférences d'orientation de remorquage.",
      "ignoreFrontBack": "Autoriser l'algorithme à utiliser votre préférence de rangée avant ou arrière.",
      "ignoreOutsideHangar": "Autoriser l'algorithme à prendre en compte vos préférences « facultatif ».",
      "cloudPrioritization": "Utilise la priorisation de position « Cloud » (ConvexHull) pour déterminer quelles positions évaluer."
    }
  },
  "evaluatingStackDialog": {
    "titles": {
      "selectStack": "Sélectionner une pile",
      "evaluating": "Évaluation de la pile"
    },
    "progress": {
      "preparing": "Préparation au décollage...",
      "scenariosEvaluated": "{{formattedCount}} scénarios évalués"
    },
    "complete": {
      "modifyLink": "Essayez de modifier vos critères.",
      "finishedMessage": "Message terminé"
    },
    "buttons": {
      "cancel": "Annuler la pile",
      "endEarly": "Terminer l'empilement"
    }
  },
  "runStack": {
    "buttons": {
      "autoStack": "AutoStack",
      "autoStackDev": "AutoStack Dev",
      "results": "Résultats",
      "cancel": "Annuler",
      "customizeStack": "Personnaliser la pile",
      "runStack": "Exécuter"
    },
    "tooltips": {
      "autoStack": "AutoStack",
      "results": "Résultats"
    },
    "dialog": {
      "title": "AutoStack"
    },
    "alerts": {
      "lockReminder": "N'oubliez pas de verrouiller les aéronefs qui ne doivent pas être déplacés."
    }
  },
  "selectStackStrategy": {
    "common": {
      "notAvailable": "S/O",
      "noOverlap": "Sans conflit"
    },
    "strategies": {
      "normal": {
        "title": "Normal",
        "description": "Opérations quotidiennes avec les SOP."
      },
      "tight": {
        "title": "Serré",
        "description": "Optimisé pour une utilisation maximale."
      },
      "loose": {
        "title": "Lâche",
        "description": "Optimisé pour un remorquage facile, au détriment de l'utilisation."
      },
      "custom": {
        "title": "Perso.",
        "description": "Personnalisez entièrement vos préférences de pile."
      }
    },
    "spacing": {
      "horizontal": "Horizontal : {{value}}",
      "overlapMin": "Chevauchement min. : {{value}}"
    }
  },
  "selectTowingEquipment": {
    "labels": {
      "towingEquipment": "Équipement de remorquage pour pile",
      "ignore": "Ignorer ?"
    }
  },
  "stackResult": {
    "utilization": "Utilisation",
    "inside": "Intérieur",
    "outside": "Extérieur",
    "selectStack": "Choisir la pile",
    "flagPoorLayout": "Signaler mise en page"
  },
  "hangarPrintLayout": {
    "aircraft": "Aéronef",
    "utilization": "Utilisation",
    "estValue": "Val. est.",
    "estTowTime": "Tps remor.",
    "footer": {
      "automaticallyOptimizedBy": "Optimisé automatiquement par",
      "contactInfo": "Contactez-nous sur www.airplx.com ou à peter@airplx.com."
    }
  }
}
